import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { PasswordModule } from '../password/password.module';
import { LoginComponent } from './login.component';

const COMPONENTS = [
	LoginComponent
];

const MODULES = [
	CommonModule,
	ReactiveFormsModule,
	PasswordModule
];

@NgModule({
	declarations: [...COMPONENTS],
	imports: [...MODULES],
	exports: [...COMPONENTS]
})
export class LoginModule { }
